import { jwtDecode } from 'jwt-decode';
import { Profile } from '../models/profile';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Login } from '../models/login';
import { environment } from 'src/environments/environment.dev';
import { Customer } from '../models/customer';

export function decodeToken(token: string): Profile{
  return setProfile(jwtDecode(token));
}

export function mapToLogin(loginForm: FormGroup): Login{
  return{
    username: loginForm.controls['username'].value,
    password: loginForm.controls['password'].value,
    client_id: environment.clientId,
    client_secret: environment.client_secret
  }
}

function setProfile(profile: any): Profile {
  return {
    name: profile.name,
    email: profile.email,
    acr: profile.acr,
    azp: profile.azp,
    exp: profile.exp,
    family_name: profile.family_name,
    given_name: profile.given_name,
    iat: profile.iat,
    jti: profile.jti,
    preferred_username: profile.preferred_username,
    realm_access: profile.realm_access,
    resource_access: profile.resource_access,
    scope: profile.scope,
    sid: profile.sid,
    sub: profile.sub,
    typ: profile.typ,
    email_verified: profile.email_verified,
    aud: profile.aud,
  };
}
